module.exports = __webpack_public_path__ + "img/logo-4@2x.0b12ff92.png";